import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const iconButtonDefaultVariants = {
  "hierarchy": "primary",
  "size": "medium"
}
const iconButtonCompoundVariants = [
  {
    "css": {
      "root": {
        "_disabled": {
          "color": "content.interaction.disabled",
          "cursor": "not-allowed",
          "border": "none"
        }
      }
    }
  },
  {
    "hierarchy": [
      "primary",
      "secondary",
      "tertiary"
    ],
    "css": {
      "root": {
        "_disabled": {
          "bg": "background.interaction.disabled"
        }
      }
    }
  }
]

const iconButtonSlotNames = [
  [
    "root",
    "iconButton__root"
  ]
]
const iconButtonSlotFns = /* @__PURE__ */ iconButtonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, iconButtonDefaultVariants, getSlotCompoundVariant(iconButtonCompoundVariants, slotName))])

const iconButtonFn = memo((props = {}) => {
  return Object.fromEntries(iconButtonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const iconButtonVariantKeys = [
  "hierarchy",
  "size"
]
const getVariantProps = (variants) => ({ ...iconButtonDefaultVariants, ...compact(variants) })

export const iconButton = /* @__PURE__ */ Object.assign(iconButtonFn, {
  __recipe__: false,
  __name__: 'iconButton',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: iconButtonVariantKeys,
  variantMap: {
  "hierarchy": [
    "primary",
    "secondary",
    "tertiary",
    "quaternary"
  ],
  "size": [
    "large",
    "medium",
    "small"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, iconButtonVariantKeys)
  },
  getVariantProps
})